import { PriorityRequestFormFilter, PriorityRequestReachabilityFilter, ReachabilityWindowResponse } from "@/api";

import { PriorityRequestFilters, ReachabilityDay } from "./PriorityRequests.types";

export const PRIORITY_REQUESTS_REFETCH_INTERVAL_MS = 60_000;

const WINDOW_SEPARATOR = ", ";

export const DEFAULT_PRIORITY_REQUEST_FILTERS: PriorityRequestFilters = {
  counselorId: null,
  reachability: PriorityRequestReachabilityFilter.All,
  form: PriorityRequestFormFilter.All,
};

export const REACHABILITY_FILTER_OPTIONS = [
  PriorityRequestReachabilityFilter.All,
  PriorityRequestReachabilityFilter.Reachable,
  PriorityRequestReachabilityFilter.NotReachable,
];

export const FORM_FILTER_OPTIONS = [
  PriorityRequestFormFilter.All,
  PriorityRequestFormFilter.Prepared,
  PriorityRequestFormFilter.NotPrepared,
];

export function groupReachabilityWindows(windows: ReachabilityWindowResponse[]): ReachabilityDay[] {
  const days: ReachabilityDay[] = [];

  for (const window of windows) {
    const range = `${window.from}–${window.to}`;
    const day = days.find((d) => d.weekday === window.weekday);
    if (day) {
      day.windows = `${day.windows}${WINDOW_SEPARATOR}${range}`;
    } else {
      days.push({ weekday: window.weekday, windows: range });
    }
  }

  return days;
}

export const priorityRequestFiltersKey = (filters: PriorityRequestFilters) =>
  `${filters.counselorId ?? ""}|${filters.reachability}|${filters.form}`;

const CONSEQUENCE_PREFIX = "- ";

export const formatConsequences = (intro: string, consequences: string[]) =>
  [intro, ...consequences.map((consequence) => `${CONSEQUENCE_PREFIX}${consequence}`)].join("\n");
